import { createElement } from 'react'
import { l } from '@manychat/manyui'

import type { ProAlertOptions } from 'common/billing/billingService/interfaces'
import ProAlert from 'common/billing/components/ProAlert'
import { alert } from 'common/core'
import { analyticsService } from 'utils/services/analytics'

export const showProAlert = (options: ProAlertOptions): Promise<boolean> => {
  return new Promise((resolve) => {
    const { title, source, buttonLabel } = options
    const message =
      options.message ||
      options.proError?.message ||
      l.translate(
        "You aren't able to activate this feature on the current plan. Upgrade for unlimited access.",
      )

    const modalTitle = title || options.proError?.message
    const products = options.products || options.proError?.error_data?.products
    const addOns = options.addOns || options.proError?.error_data?.addons

    const alertContent = createElement(ProAlert, {
      ...options,
      title: modalTitle,
      products,
      addOns,
      message,
      buttonLabel,
      onUpgrade: resolve,
    })

    analyticsService.sendEvent('SESSION_QUALITY.PRO_ALERT_VISIBLE', { source })

    alert('', undefined, {
      isTemporary: false,
      icon: 'Warning',
      content: alertContent,
    })
  })
}
